import type { BonusId } from "./gameplay-config";

export interface BonusVisualStyle {
  readonly fillColor: number;
  readonly iconColor: number;
  readonly outlineColor: number;
}

export const bonusVisualConfig: {
  readonly feedbackDurationMs: number;
  readonly haloColor: number;
  readonly haloGap: number;
  readonly haloPulseAmount: number;
  readonly haloPulseDurationMs: number;
  readonly reducedMotionFeedbackDurationMs: number;
  readonly styles: Readonly<Record<BonusId, BonusVisualStyle>>;
} = {
  feedbackDurationMs: 700,
  haloColor: 0xfff7d6,
  haloGap: 6,
  haloPulseAmount: 3,
  haloPulseDurationMs: 1_400,
  reducedMotionFeedbackDurationMs: 900,
  styles: {
    turbo: {
      fillColor: 0xffd43b,
      iconColor: 0x6b3f00,
      outlineColor: 0x183b54,
    },
  },
};
